import EditableTextPillButton from '../EditableTextPillButton';
import {StyledRoundedButton} from '../styled';
import {Position} from '../types';
import {blue05, blue50} from '@planday-corp/ui/styles/colors';
import Text from '@planday-corp/ui/text/Text';
import {styled} from 'styled-components';

const PillWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  flex-wrap: wrap;
  padding-top: 0.5rem;
`;

export const PillButton = styled(StyledRoundedButton)`
  background-color: ${blue05};
  border-color: ${blue50};
`;

interface PillsProps {
  positions: Position[];
  onPillClick: (name: string) => void;
  onNewPositionAdded: (name: string) => void;
}

export default function Pills({
  positions,
  onPillClick,
  onNewPositionAdded,
}: PillsProps) {
  return (
    <div>
      <Text value={'What roles make up your team?'} size="label" />
      <PillWrapper>
        {positions.map(position => (
          <PillButton
            key={position.name}
            iconRight={position.isRemovable ? 'closeBig' : undefined}
            type="info"
            onClick={() => onPillClick(position.name)}
          >
            {position.name}
          </PillButton>
        ))}
        <EditableTextPillButton onChange={onNewPositionAdded} />
      </PillWrapper>
    </div>
  );
}
